<sd-6-17-1-dialog
  #dialog
  [headline]="headline | transloco: { format: format() }"
  (afterHide)="onAfterHide()">
  <div class="export-dialog">
    <p class="question">
      @if (fund(); as fundName) {
        {{ questionWithFundLabel | transloco: { fund: fundName } }}
      } @else {
        {{ questionLabel | transloco }}
      }
    </p>

    <sd-6-17-1-radio-group
      [value]="scope()"
      (sd-change)="selectScope($event)">
      @for (curOption of scopeOptions; track curOption.scope) {
        <sd-6-17-1-radio
          class="option"
          [class.option--selected]="scope() === curOption.scope"
          [value]="curOption.scope">
          <div class="option-content">
            <p class="option-title">{{ curOption.label | transloco }}</p>
            <p class="option-description">{{ curOption.description | transloco }}</p>
            @if (curOption.scope === 'current' && activeFilterLabels().length > 0) {
              <div class="option-tags">
                @for (label of activeFilterLabels(); track $index) {
                  <span class="option-tag">{{ label }}</span>
                }
              </div>
            }
          </div>
        </sd-6-17-1-radio>
      }
    </sd-6-17-1-radio-group>

    @if (errorMessage(); as error) {
      <p class="error-message">{{ error }}</p>
    }

    <div class="dialog-actions">
      <sd-6-17-1-button
        variant="secondary"
        type="button"
        (click)="cancel()">
        {{ cancelLabel | transloco }}
      </sd-6-17-1-button>
      <sd-6-17-1-button
        wctLoadingIndicator
        [apiCallAdditionalLoading]="saving"
        variant="primary"
        type="button"
        [disabled]="!canConfirm"
        (click)="confirm()">
        {{ confirmLabel | transloco }}
      </sd-6-17-1-button>
    </div>
  </div>
</sd-6-17-1-dialog>
